import { Component, inject, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkDragDrop, CdkDrag, CdkDropList, CdkDragHandle, moveItemInArray } from '@angular/cdk/drag-drop';

import { WebsiteStateService } from '../../state-management/services/website-state.service';
import { Section, ComponentItem } from '../../state-management/model/interfaces/state.model';

import { Navbar } from '../../components/shared/navbar/navbar.component';
import { CHeroComponent } from '../../components/composed/c-hero/c-hero.component';
import { CTwoColumnTextImageComponent } from '../../components/composed/c-two-column-text-image/c-two-column-text-image.component';
import { CSingleColumnTextImageComponent } from '../../components/composed/c-single-column-text-image/c-single-column-text-image.component';
import { CFeatureBannerComponent } from '../../components/composed/c-feature-banner/c-feature-banner.component';
import { CCardsGalleryComponent } from '../../components/composed/c-cards-gallery/c-cards-gallery.component';
import { CContactFormComponent } from '../../components/composed/c-contact-form/c-contact-form.component';
import { CCardsSideBySideComponent } from '../../components/composed/c-cards-side-by-side/c-cards-side-by-side.component';
import { CGoogleMapsComponent } from '../../components/composed/c-google-maps/c-google-maps.component';
import { CReviewsComponent } from '../../components/composed/c-reviews/c-reviews.component';
import { FooterComponent } from '../../components/static/footer/footer.component';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

import { ConfigurationComponent } from '../../admin/components/configuration/configuration.component';
import { CImageGalleryComponent } from '../../components/composed/c-image-gallery/c-image-gallery.component';

@Component({
  selector: 'app-page',
  standalone: true,
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
  imports: [
    CommonModule,
    CImageGalleryComponent,
    CdkDrag,
    CdkDragHandle,
    CdkDropList,
    MatIcon,
    MatMenuModule,
    MatButtonModule,
    ConfigurationComponent,
    Navbar,
    CHeroComponent,
    CSingleColumnTextImageComponent,
    CTwoColumnTextImageComponent,
    CFeatureBannerComponent,
    CCardsGalleryComponent,
    CContactFormComponent,
    CGoogleMapsComponent,
    CCardsSideBySideComponent,
    CReviewsComponent,
    FooterComponent,
  ]
})
export class PageComponent {
  private stateService = inject(WebsiteStateService);
  public isEditMode$: Signal<boolean> = this.stateService.isEditMode;

  public sortedActiveSections$: Signal<Section[]> = this.stateService.sortedActiveSections;
  public sortedActiveComponents$: Signal<Record<string, ComponentItem[]>> = this.stateService.sortedActiveComponents;


  public drop(event: CdkDragDrop<any, any, any>, sectionId: string): void {
    moveItemInArray(this.sortedActiveComponents$()[sectionId], event.previousIndex, event.currentIndex);
    let components = this.sortedActiveComponents$()[sectionId].map(component => component.id);
    this.stateService.updateSection(sectionId, { components });
  }
}